export const calculateNavigationPercent = (currentStep: number, totalSteps: number) => {
  if (!currentStep) return 0;

  if (currentStep > totalSteps) return 100;

  return roundToNearestMultipleBy(Math.round((100 / totalSteps) * currentStep), 5);
};

function roundToNearestMultipleBy(num: number, mult: number): number {
  return Math.round(num / mult) * mult;
}
